<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>


<div [class.isPrinting]="printService.isPrinting">


  <div class="job-posts placements agreements margin-top-service-30px">
    <div class="card my-profile-form skillassest-form">



    </div>
    <div class="card-body padding-top padding-left-0px padding-bottom-0px padding-right-0px">
      <div class="row">
        <div class="col-md-3 padding-right-0px colmd3">
          <div class="position-fixed-scans border-right2 padding-right-5px height-100pe">
            <div class="card height-100pe">

              <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
                <div class="row margin-top10px margin-left-20px  nav-link-hand">
                  <div class="col-md-10 padding-left-0px">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Embryo Grading
                    </label>
                  </div>


                  <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

                    <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
                  </div>-->


                  <div class="col-md-1">
                    <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                  </div>
                  <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                  *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>-->

                </div>




              </div>
              <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
                <div class="row border-top margin-left-0px margin-right-0px">
                  <div class="col-md-5 col-sm-4 padding-right-0px my-profile-form margin-left-10px">
                    <div class="date-form margin-top-5px form-group margin-bottom-0px">
                      <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>



                  </div>
                  <div class="col-md-1 " (click)="DecrementDate()">
                    <a title="Previous" class="nav-link-hand">
                      <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                  <div class="col-md-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                    <a title="Next" class="nav-link-hand">
                      <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                </div>
                <div class="row margin-right-0px margin-left-0px">
                  <div class="col-md-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                    <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                  </div>
                  <div class="col-md-2" hidden>
                    <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Edit">
                      <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                    </a>

                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Delete">
                      <span class="badge font-size-14">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </a>
                  </div>

                </div>
                <div>
                  <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps scroll padding-lrt " data-ps-id="dfsfsde">

                    <!--<div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>
                    <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>-->
                    <div *ngIf="isRequesting">
                      <div class="loader-text">
                        <div class="loader-text2">

                          <div class="lds-facebook">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                          <div class="margin-top-20px margin-left-5px">
                            <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                          </div>
                          <!--Loading Please Wait...-->
                        </div>
                      </div>
                      <!--<div class="loadernew"></div>-->


                    </div>
                    <div *ngIf="!isRequesting">
                      <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient(l)" *ngFor="let l of pdata">
                        <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient(l)">
                          <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.OwnerPatientImageFile" onError="this.src='dummy.jpg';">



                        </div>
                        <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.OwnerName}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerAgeYears}} years,{{l.OwnerFormattedCode}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-4">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerTelephone1}}</label>
                            </div>
                          </div>

                        </div>
                        <div class="col-md-3 padding-left-0px margin-top-5px">
                          <div class="text-align-center"><label class="font-size-12px">#{{l.CycleNo}}</label></div>
                          <div class="text-align-center">
                            <a data-toggle="tooltip" data-placement="bottom" title="Completed" *ngIf="l.ActivityStatus=='Completed'">

                              <i class="fas fa-check-circle color-icon-completed font-size-16px">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="Initiated" *ngIf="l.ActivityStatus=='Initiated'">

                              <i class="fas fa-check-circle color-gray font-size-16px">
                              </i>
                            </a>
                          </div>
                          <!--<div class="text-align-center"><label class="font-size-12px">{{l.LastUpdatedTime | date: 'hh:mm a'}}</label></div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="col-md-9 " *ngIf="ScanDetails">

          <div class="row">
            <div class="col-md-12 padding-left-0px">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px">
                  <div class="row">
                    <div class="col-md-1 ">
                      <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.EggPatientImageFile" onError="this.src='dummy.jpg';">
                    </div>
                    <div class="col-md-4">
                      <div class="row row-height-17px margin-left-0px">
                        <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.EggName}} </label>
                      </div>
                      <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>
                      <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>-->

                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggAgeYears}},{{SelectedpatientDetails.EggFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggTelephone1}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-2">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
                        </div>
                        <div class="col-md-9 padding-left-6px">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
                        </div>

                      </div>
                    </div>
                    <div class="col-md-7  padding-right-0px padding-left-0px">
                      <!--<div class="row font-size-12px">
    <div class="col-md-9 margin-left-auto text-align-right padding-right-10px">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
    </div>:
    <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="SemanAnalysis2">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">{{SemanAnalysis2.LastUpdatedTime | date: 'hh:mm a'}}</label>
    </div>
  </div>-->

                      <div class="row font-size-12px margin-left-0px margin-right-0px">
                        <div class="col-md-9 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                        </div>:
                        <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="SemanAnalysis2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{SemanAnalysis2.ActivityStatus}}</label>
                        </div>
                      </div>
                      <div class="row font-size-12px margin-left-0px margin-right-0px">
                        <div class="col-md-9 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Insemination Date</label>
                        </div>:
                        <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="ActorCodeDetails">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{ActorCodeDetails.DateOfInsemination | date:'MMM-dd-yyyy'}}</label>
                        </div>
                      </div>
                      <div class="row font-size-12px margin-left-0px margin-right-0px">
                        <div class="col-md-9 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Insemination Time </label>
                        </div>:
                        <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="ActorCodeDetails">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{ActorCodeDetails.DateOfInsemination | date: 'hh:mm a'}}</label>
                        </div>
                      </div>
                      <!--<div class="row font-size-12px">
    <div class="col-md-9 margin-left-auto text-align-right padding-right-10px">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">Insemination Date </label>
    </div>:
    <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="ActorCodeDetails">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">{{ActorCodeDetails.DateOfInsemination | date:'MMM-dd-yyyy'}}</label>
    </div>
  </div>-->

                      <div class="row margin-right-0px" hidden>
                        <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
                        </div>
                        <div class="Dsa2" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
                        </div>
                        <div class="Dsa3 margin-right-5pe" *ngIf="DSADetails">

                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-right-0px padding-top-0px padding-bottom-0px">
                  <div class="card margin-right-54px">
                    <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px bk-color-light">
                      <div class="row nav-link-hand margin-right-0px" id="edit-link">
                        <div class="col-md-6 padding-right-0px">
                          <label class="margin-bottom-0px font-size-16px font-weight-normal">
                            Embryo Grading
                          </label>
                        </div>
                        <div class="col-md-5  padding-right-0px ">
                          <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                          <div class="row float-right" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                            <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2 && SelectedpatientDetails.GradingModel=='Well Culture'">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>-->
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                              <!--<a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheckDrop()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed' || SelectedpatientDetails.GradingModel=='Droplet Culture'">Is Grading Completed</a>-->
                            </div>

                            <div class="col-md-1" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgrading()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>
                          </div>

                          <div class="row float-right" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                            <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2 && SelectedpatientDetails.GradingModel=='Well Culture'">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>-->
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                              <!--<a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed' || SelectedpatientDetails.GradingModel=='Well Culture'">Is Grading Completed</a>-->
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>
                            <div class="col-md-1">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgradingdroplet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>

                            <!--<div class="col-md-1" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgradingdroplet()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>-->
                          </div>
                          <div class="row float-right" *ngIf="SelectedpatientDetails.TCModelName=='Fet' && SelectedpatientDetails.GradingModel=='Well Culture' ">
                            <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2 && SelectedpatientDetails.GradingModel=='Well Culture'">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>-->
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                              <!--<a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed' || SelectedpatientDetails.GradingModel=='Well Culture'">Is Grading Completed</a>-->
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheckDrop()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>

                            <div class="col-md-1">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printfet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>
                            <!--<div class="col-md-1" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgradingdroplet()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>-->
                          </div>
                          <div class="row float-right" *ngIf="SelectedpatientDetails.TCModelName=='Fet' && SelectedpatientDetails.GradingModel=='Droplet Culture' ">
                            <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2 && SelectedpatientDetails.GradingModel=='Well Culture'">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>-->
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                              <!--<a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed' || SelectedpatientDetails.GradingModel=='Well Culture'">Is Grading Completed</a>-->
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheckDrop()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>

                            <div class="col-md-1">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printfet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>
                            <!--<div class="col-md-1" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgradingdroplet()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>-->
                          </div>

                        </div>

                      </div>
                    </div>

                    <div class="card-body padding-right-0px padding-left-0px padding-top-0px">
                      <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps overflow-x-hidden padding-lrt " data-ps-id="dfsfsde" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                        <div class="table-component">
                          <div class="table-responsive">


                            <table class="table table-striped margin-left-zero width-50-new">
                              <thead class="">
                                <tr>

                                  <th class="th-width-71px">
                                    S.No
                                  </th>


                                  <th class="td-well-width-79px">
                                    Well #
                                  </th>

                                  <th class="th-width-95px">Denuded</th>
                                  <th>
                                    Ins.Tech
                                  </th>

                                  <th class="">
                                    Day1
                                  </th>
                                  <th class="">
                                    Day2
                                  </th>
                                  <th class="">
                                    Day3
                                  </th>

                                  <th class="">
                                    Day4
                                  </th>

                                  <th class="">
                                    Day5
                                  </th>
                                  <th class="">
                                    Day6
                                  </th>


                                </tr>
                              </thead>

                              <tbody class="table-body">
                                <tr *ngFor="let l of CurrentSingleWellCultureByCycleCodeController;let i = index">

                                  <td>{{i+1}}</td>
                                  <td class="padding-left-0px padding-right-0px text-align-center">{{l.WellNo}}</td>
                                  <td>{{l.OocyteQualityPost}}</td>
                                  <td>{{l.Technique}}</td>
                                  <td class="padding-top-4px padding-bottom-4px padding-left-0px padding-right-0px">

                                    <div class="card border-all-1px nav-link-hand" (click)="SelectedEmbryo(l,1)" *ngIf="l.Grade1">
                                      <!--<div class="card-header padding-all-0px text-align-center border-bottom-0px">


                                      </div>-->
                                      <div class="card-body padding-right-0px padding-bottom-0px padding-top-0px padding-left-0px">
                                        <!--<div class="row">
                                          <div><label>AA</label></div>
                                          <div><img class="border-radius-50p nav-link-hand margin-top-3px" height="35px" src="Day-5-Embryo.jpg" width="35px"></div>
                                          <div>
                                            <div class="badge badge-oocytes  background-red margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                        </div>-->
                                        <div class="row margin-left-0px">
                                          <div>
                                            <label class="margin-left-3px">{{l.Grade1}}</label>
                                          </div>
                                          <div>
                                            <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" width="35px" [src]="GetImageUrl(l,1)" onError="this.src='dummy.jpg';">
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.isDisCarded">
                                            <div class="badge badge-grading-discard  margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.IsFrozen">
                                            <div class="badge badge-grading-Freeze  margin-bottom-3px">
                                              F
                                            </div>
                                          </div>
                                          <div class="padding-top-35px"
                                               *ngIf="l.IsTransferrable">
                                            <div class="badge badge-grading-Transfer  margin-bottom-3px">
                                              T
                                            </div>
                                          </div>
                                        </div>
                                        <!--<div class="row">


                                        </div>
                                        <div class="row">

                                        </div>-->

                                      </div>
                                      <!--<div class="card-footer border-top-0 padding-all-0px margin-top-3px text-align-center">

                                      </div>-->
                                    </div>
                                    <div class="nav-link-hand" (click)="SelectedEmbryo(l,1)" *ngIf="CanAddGrade(l,1)">
                                      <button type="button"
                                              class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary " id="FileUpload"
                                              name="upload">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                    </div>
                                  </td>

                                  <td>

                                    <div class="card border-all-1px nav-link-hand" (click)="SelectedEmbryo(l,2)" *ngIf="l.Grade2">
                                      <!--<div class="card-header padding-all-0px text-align-center border-bottom-0px">


                                      </div>-->
                                      <div class="card-body padding-right-0px padding-bottom-0px padding-top-0px padding-left-0px">
                                        <!--<div class="row">
                                          <div><label>AA</label></div>
                                          <div><img class="border-radius-50p nav-link-hand margin-top-3px" height="35px" src="Day-5-Embryo.jpg" width="35px"></div>
                                          <div>
                                            <div class="badge badge-oocytes  background-red margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                        </div>-->
                                        <div class="row margin-left-0px">
                                          <div>
                                            <label class="margin-left-3px">{{l.Grade2}}</label>
                                          </div>
                                          <div>
                                            <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" width="35px" [src]="GetImageUrl(l,2)" onError="this.src='dummy.jpg';">
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.isDisCarded">
                                            <div class="badge badge-grading-discard  margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.IsFrozen">
                                            <div class="badge badge-grading-Freeze  margin-bottom-3px">
                                              F
                                            </div>
                                          </div>
                                          <div class="padding-top-35px"
                                               *ngIf="l.IsTransferrable">
                                            <div class="badge badge-grading-Transfer  margin-bottom-3px">
                                              T
                                            </div>
                                          </div>
                                        </div>
                                        <!--<div class="row">


                                        </div>
                                        <div class="row">

                                        </div>-->

                                      </div>
                                      <!--<div class="card-footer border-top-0 padding-all-0px margin-top-3px text-align-center">

                                      </div>-->
                                    </div>
                                    <div class="  nav-link-hand" (click)="SelectedEmbryo(l,2)" *ngIf="CanAddGrade(l,2)">
                                      <button type="button"
                                              class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary " id="FileUpload"
                                              name="upload">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                    </div>
                                  </td>
                                  <td>

                                    <div class="card border-all-1px nav-link-hand " (click)="SelectedEmbryo(l,3)" *ngIf="l.Grade3">
                                      <!--<div class="card-header padding-all-0px text-align-center border-bottom-0px">


                                      </div>-->
                                      <div class="card-body padding-right-0px padding-bottom-0px padding-top-0px padding-left-0px">
                                        <!--<div class="row">
                                          <div><label>AA</label></div>
                                          <div><img class="border-radius-50p nav-link-hand margin-top-3px" height="35px" src="Day-5-Embryo.jpg" width="35px"></div>
                                          <div>
                                            <div class="badge badge-oocytes  background-red margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                        </div>-->
                                        <div class="row margin-left-0px">
                                          <div>
                                            <label class="margin-left-3px">{{l.Grade3}}</label>
                                          </div>
                                          <div>
                                            <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" width="35px" [src]="GetImageUrl(l,3)" onError="this.src='dummy.jpg';">
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.isDisCarded">
                                            <div class="badge badge-grading-discard  margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.IsFrozen">
                                            <div class="badge badge-grading-Freeze  margin-bottom-3px">
                                              F
                                            </div>
                                          </div>
                                          <div class="padding-top-35px"
                                               *ngIf="l.IsTransferrable">
                                            <div class="badge badge-grading-Transfer  margin-bottom-3px">
                                              T
                                            </div>
                                          </div>
                                        </div>
                                        <!--<div class="row">


                                        </div>
                                        <div class="row">

                                        </div>-->

                                      </div>
                                      <!--<div class="card-footer border-top-0 padding-all-0px margin-top-3px text-align-center">

                                      </div>-->
                                    </div>
                                    <div class="  nav-link-hand" (click)="SelectedEmbryo(l,3)" *ngIf="CanAddGrade(l,3)">
                                      <button type="button"
                                              class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary " id="FileUpload" (click)="Addactivity()"
                                              name="upload">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                    </div>
                                  </td>
                                  <td>

                                    <div class="card border-all-1px nav-link-hand " (click)="SelectedEmbryo(l,4)" *ngIf="l.Grade4">
                                      <!--<div class="card-header padding-all-0px text-align-center border-bottom-0px">


                                      </div>-->
                                      <div class="card-body padding-right-0px padding-bottom-0px padding-top-0px padding-left-0px">
                                        <!--<div class="row">
                                          <div><label>AA</label></div>
                                          <div><img class="border-radius-50p nav-link-hand margin-top-3px" height="35px" src="Day-5-Embryo.jpg" width="35px"></div>
                                          <div>
                                            <div class="badge badge-oocytes  background-red margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                        </div>-->
                                        <div class="row margin-left-0px">
                                          <div>
                                            <label class="margin-left-3px">{{l.Grade4}}</label>
                                          </div>
                                          <div>
                                            <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" width="35px" [src]="GetImageUrl(l,4)" onError="this.src='dummy.jpg';">
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.isDisCarded">
                                            <div class="badge badge-grading-discard  margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.IsFrozen">
                                            <div class="badge badge-grading-Freeze  margin-bottom-3px">
                                              F
                                            </div>
                                          </div>
                                          <div class="padding-top-35px"
                                               *ngIf="l.IsTransferrable">
                                            <div class="badge badge-grading-Transfer  margin-bottom-3px">
                                              T
                                            </div>
                                          </div>
                                        </div>
                                        <!--<div class="row">


                                        </div>
                                        <div class="row">

                                        </div>-->

                                      </div>
                                      <!--<div class="card-footer border-top-0 padding-all-0px margin-top-3px text-align-center">

                                      </div>-->
                                    </div>
                                    <div class="nav-link-hand" (click)="SelectedEmbryo(l,4)" *ngIf="CanAddGrade(l,4)">
                                      <button type="button"
                                              class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary " id="FileUpload" (click)="Addactivity()"
                                              name="upload">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                    </div>
                                  </td>
                                  <td>

                                    <div class="card border-all-1px nav-link-hand " (click)="SelectedEmbryo(l,5)" *ngIf="l.Grade5">
                                      <!--<div class="card-header padding-all-0px text-align-center border-bottom-0px">


                                      </div>-->
                                      <div class="card-body padding-right-0px padding-bottom-0px padding-top-0px padding-left-0px">
                                        <!--<div class="row">
                                          <div><label>AA</label></div>
                                          <div><img class="border-radius-50p nav-link-hand margin-top-3px" height="35px" src="Day-5-Embryo.jpg" width="35px"></div>
                                          <div>
                                            <div class="badge badge-oocytes  background-red margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                        </div>-->
                                        <div class="row margin-left-0px">
                                          <div>
                                            <label class="margin-left-3px">{{l.Grade5}}</label>
                                          </div>
                                          <div>
                                            <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" width="35px" [src]="GetImageUrl(l,5)" onError="this.src='dummy.jpg';">
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.isDisCarded">
                                            <div class="badge badge-grading-discard  margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.IsFrozen">
                                            <div class="badge badge-grading-Freeze  margin-bottom-3px">
                                              F
                                            </div>
                                          </div>
                                          <div class="padding-top-35px"
                                               *ngIf="l.IsTransferrable">
                                            <div class="badge badge-grading-Transfer  margin-bottom-3px">
                                              T
                                            </div>
                                          </div>
                                        </div>
                                        <!--<div class="row">


                                        </div>
                                        <div class="row">

                                        </div>-->

                                      </div>
                                      <!--<div class="card-footer border-top-0 padding-all-0px margin-top-3px text-align-center">

                                      </div>-->
                                    </div>
                                    <div class="nav-link-hand" (click)="SelectedEmbryo(l,5)" *ngIf="CanAddGrade(l,5)">
                                      <button type="button"
                                              class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary" id="FileUpload" (click)="Addactivity()"
                                              name="upload">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                    </div>
                                  </td>
                                  <td>

                                    <div class="card border-all-1px nav-link-hand " (click)="SelectedEmbryo(l,6)" *ngIf="l.Grade6">
                                      <!--<div class="card-header padding-all-0px text-align-center border-bottom-0px">


                                      </div>-->
                                      <div class="card-body padding-right-0px padding-bottom-0px padding-top-0px padding-left-0px">
                                        <!--<div class="row">
                                          <div><label>AA</label></div>
                                          <div><img class="border-radius-50p nav-link-hand margin-top-3px" height="35px" src="Day-5-Embryo.jpg" width="35px"></div>
                                          <div>
                                            <div class="badge badge-oocytes  background-red margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                        </div>-->
                                        <div class="row margin-left-0px">
                                          <div>
                                            <label class="margin-left-3px">{{l.Grade6}}</label>
                                          </div>
                                          <div>
                                            <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" width="35px" [src]="GetImageUrl(l,6)" onError="this.src='dummy.jpg';">
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.isDisCarded">
                                            <div class="badge badge-grading-discard  margin-bottom-3px">
                                              D
                                            </div>
                                          </div>
                                          <div class="padding-top-35px" *ngIf="l.IsFrozen">
                                            <div class="badge badge-grading-Freeze  margin-bottom-3px">
                                              F
                                            </div>
                                          </div>
                                          <div class="padding-top-35px"
                                               *ngIf="l.IsTransferrable">
                                            <div class="badge badge-grading-Transfer  margin-bottom-3px">
                                              T
                                            </div>
                                          </div>
                                        </div>
                                        <!--<div class="row">


                                        </div>
                                        <div class="row">

                                        </div>-->

                                      </div>
                                      <!--<div class="card-footer border-top-0 padding-all-0px margin-top-3px text-align-center">

                                      </div>-->
                                    </div>
                                    <div class="nav-link-hand" (click)="SelectedEmbryo(l,6)" *ngIf="CanAddGrade(l,6)">
                                      <button type="button"
                                              class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary" id="FileUpload" (click)="Addactivity()"
                                              name="upload">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                    </div>
                                  </td>


                                </tr>



                              </tbody>

                            </table>

                          </div>
                        </div>

                        <div class="accordion" id="accordionExample2" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture' && SelectedpatientDetails.TCModelName!='Fet'">

                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                      Embryo Storage
                                    </button>
                                  </h5>
                                </div>
                                <div class="col-md-8">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                  <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                </div>
                                <!--<div class="col-md-6">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                </div>-->
                              </div>


                            </div>

                            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                              <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                <div class="card margin-bottom-0px margin-top-10" *ngIf="SemanAnalysis2">

                                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                                    <div class="row " *ngIf="CurrentIvfOocyteEmbryoStorageByCodeController ==null || CurrentIvfOocyteEmbryoStorageByCodeController.length == 0 ">
                                      <button (click)="Store()" class="btn font-size-13px actions-btn-prime margin-left-auto margin-right-auto">Init Store</button>

                                    </div>
                                    <div class="row" *ngIf="CurrentIvfOocyteEmbryoStorageByCodeController ==null || CurrentIvfOocyteEmbryoStorageByCodeController.length == 0 ">
                                      <div class="col-md-6 margin-left-auto margin-right-auto">
                                        <label class="color-Rejected  font-size-11px">(This operation cannot be repeated once storage is initiated and saved )</label>
                                      </div>



                                    </div>
                                    <div class="row">
                                      <div class="col-md-12 ">
                                        <div class="table-component" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                          <div class="table-responsive">


                                            <table class="table table-striped margin-left-zero">

                                              <thead class="">
                                                <tr>
                                                  <th class="min-width-0px padding-top-4px padding-bottom-4px"></th>


                                                  <th class="padding-top-4px padding-bottom-4px">Well#</th>

                                                  <th class="padding-top-4px padding-bottom-4px">Grade</th>
                                                  <th class="white-space-preline padding-top-4px padding-bottom-4px">Storage</th>
                                                  <th class="padding-top-4px padding-bottom-4px">Details</th>
                                                  <th class="padding-top-4px padding-bottom-4px padding-right-0px">Status</th>
                                                  <th class="padding-top-4px padding-bottom-4px padding-left-0px padding-right-0px" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'"></th>
                                                </tr>
                                              </thead>
                                              <tbody class="table-body">
                                                <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                                <!--</ng-container>-->
                                                <tr *ngFor="let l of EmbryoStoreItems">
                                                  <td class="td-padding padding-all-0px ">

                                                    <input type="checkbox" name="l.IsSelected"
                                                           [(ngModel)]="l.IsSelected">
                                                    <i class="input-helper"></i>

                                                  </td>


                                                  <td class="text-align-center padding-top-0px padding-bottom-0px">{{l.WellNo}}</td>

                                                  <td class="padding-top-0px padding-bottom-0px">{{l.Grade}}</td>

                                                  <td class="padding-all-0px">
                                                    <CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                                                                   required></CodeTypeValue>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px">
                                                    <input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                                           id="l.StorageUnitDetails"
                                                           [(ngModel)]="l.StorageUnitDetails"
                                                           name="l.StorageUnitDetails" #Remarks="ngModel"
                                                           maxlength="100">
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">
                                                    <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                                      <i class="fas fa-circle color-Assign nav-link-hand  ">
                                                      </i>
                                                    </a>
                                                  </td>
                                                  <td class="padding-all-0px" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                                                    <button type="submit" (click)="onSubmit2(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>


                                                  </td>



                                                </tr>
                                              </tbody>

                                            </table>

                                          </div>
                                        </div>
                                        <div class="table-component" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.GradingModel!='fet'">
                                          <div class="table-responsive">


                                            <table class="table table-striped margin-left-zero">

                                              <thead class="">
                                                <tr>
                                                  <th class="min-width-0px padding-top-4px padding-bottom-4px"></th>


                                                  <th class="padding-top-4px padding-bottom-4px">GroupId</th>

                                                  <th class="padding-top-4px padding-bottom-4px">Grade</th>
                                                  <th class="white-space-preline padding-top-4px padding-bottom-4px">Storage</th>
                                                  <th class="padding-top-4px padding-bottom-4px">Details</th>
                                                  <th class="padding-top-4px padding-bottom-4px padding-right-0px">Status</th>
                                                  <th class="padding-top-4px padding-bottom-4px padding-left-0px padding-right-0px" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'"></th>
                                                </tr>
                                              </thead>
                                              <tbody class="table-body">
                                                <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                                <!--</ng-container>-->
                                                <tr *ngFor="let l of EmbryoStoreItems">
                                                  <td class="td-padding padding-all-0px ">

                                                    <input type="checkbox" name="l.IsSelected"
                                                           [(ngModel)]="l.IsSelected">
                                                    <i class="input-helper"></i>

                                                  </td>


                                                  <td class="text-align-center padding-top-0px padding-bottom-0px"></td>

                                                  <td class="padding-top-0px padding-bottom-0px">{{l.Grade}}</td>

                                                  <td class="padding-all-0px">
                                                    <CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                                                                   required></CodeTypeValue>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px">
                                                    <input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                                           id="l.StorageUnitDetails"
                                                           [(ngModel)]="l.StorageUnitDetails"
                                                           name="l.StorageUnitDetails" #Remarks="ngModel"
                                                           maxlength="100">
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">
                                                    <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                                      <i class="fas fa-circle color-Assign nav-link-hand  ">
                                                      </i>
                                                    </a>
                                                  </td>
                                                  <td class="padding-all-0px" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                                                    <button type="submit" (click)="onSubmit2(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>


                                                  </td>



                                                </tr>
                                              </tbody>

                                            </table>

                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                <div class="card margin-bottom-0px background-lightpink">

                                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                    <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero">

                                          <thead class="">
                                            <tr>
                                              <th class=" td-width-107px">Ov.Position</th>
                                              <th class="padding-left-5px width-70px">Count</th>
                                              <th class="padding-left-5px width-70px">Size</th>
                                              <th>Comments</th>

                                            </tr>
                                          </thead>
                                          <tbody class="table-body">

                                            <tr>

                                              <td>
                                                <CodeTypeValue CodeType="OVPS"
                                                               id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                                               [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                                               name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                                                </CodeTypeValue>
                                              </td>

                                              <td class="td-padding ">

                                                <input type="number" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                              </td>
                                              <td class="td-padding ">
                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                              </td>

                                              <td class="td-padding ">
                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                              </td>



                                            </tr>

                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>-->
                            </div>
                          </div>


                        </div>
                      </div>
                      <div *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.TCModelName!='Fet'" class="margin-top-10">
                        <div class="card" *ngIf="SelectedpatientDetails || SemanAnalysis2">
                          <ivfembryogradingdroplet TitleText="Day1" DOC="1" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" [CanLoadReport]='CanLoadReport' [ActivityStatus]="SemanAnalysis2.ActivityStatus" [InseminationDate]="ActorCodeDetails.DateOfInsemination" [Day]='Day' [month]='month' [Year]='Year'>

                          </ivfembryogradingdroplet>
                        </div>
                        <div class="card" *ngIf="SelectedpatientDetails || SemanAnalysis2">
                          <ivfembryogradingdroplet TitleText="Day2" DOC="2" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" [CanLoadReport]='CanLoadReport' [ActivityStatus]="SemanAnalysis2.ActivityStatus" [InseminationDate]="ActorCodeDetails.DateOfInsemination" [Day]='Day' [month]='month' [Year]='Year'>

                          </ivfembryogradingdroplet>
                        </div>

                        <div class="card" *ngIf="SelectedpatientDetails || SemanAnalysis2">
                          <ivfembryogradingdroplet TitleText="Day3" DOC="3" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" [CanLoadReport]='CanLoadReport' [ActivityStatus]="SemanAnalysis2.ActivityStatus" [InseminationDate]="ActorCodeDetails.DateOfInsemination" [Day]='Day' [month]='month' [Year]='Year'>

                          </ivfembryogradingdroplet>
                        </div>
                        <div class="card" *ngIf="SelectedpatientDetails || SemanAnalysis2">
                          <ivfembryogradingdroplet TitleText="Day4" DOC="4" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" [CanLoadReport]='CanLoadReport' [ActivityStatus]="SemanAnalysis2.ActivityStatus" [InseminationDate]="ActorCodeDetails.DateOfInsemination" [Day]='Day' [month]='month' [Year]='Year'>

                          </ivfembryogradingdroplet>
                        </div>
                        <div class="card" *ngIf="SelectedpatientDetails || SemanAnalysis2">
                          <ivfembryogradingdroplet TitleText="Day5" DOC="5" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" [CanLoadReport]='CanLoadReport' [ActivityStatus]="SemanAnalysis2.ActivityStatus" [InseminationDate]="ActorCodeDetails.DateOfInsemination" [Day]='Day' [month]='month' [Year]='Year'>

                          </ivfembryogradingdroplet>
                        </div>
                        <div class="card" *ngIf="SelectedpatientDetails || SemanAnalysis2">
                          <ivfembryogradingdroplet TitleText="Day6" DOC="6" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" [CanLoadReport]='CanLoadReport' [ActivityStatus]="SemanAnalysis2.ActivityStatus" [InseminationDate]="ActorCodeDetails.DateOfInsemination" [Day]='Day' [month]='month' [Year]='Year'>

                          </ivfembryogradingdroplet>
                        </div>

                      </div>
                      <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps overflow-x-hidden padding-lrt " data-ps-id="dfsfsde" *ngIf="SelectedpatientDetails.TCModelName=='Fet' && SelectedpatientDetails.GradingModel =='Droplet Culture' ">
                        <div class="accordion margin-top-10" id="accordionExamplefet">

                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingfet">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsefet" aria-expanded="true" aria-controls="collapsefet">
                                      Stored Embryos
                                    </button>
                                  </h5>
                                </div>
                                <div class="col-md-8 padding-left-0px text-align-center" *ngIf="SemanAnalysis2">
                                  <button type="button" (click)="Fetgrading()"
                                          class="btn  btn-sm drive-button3 background-primary border-all-secondary  margin-right-3px" id="FileUpload"
                                          name="upload " title="Click Here To Add New Row" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                                    <i class="fas fa-plus font-size-11"></i>
                                  </button>
                                </div>
                                <!--<div class="col-md-6">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                </div>-->
                              </div>


                            </div>

                            <div id="collapsefet" class="collapse show" aria-labelledby="headingfet" data-parent="#accordionExamplefet">
                              <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                <div class="card margin-bottom-0px margin-top-10">

                                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

                                    <div class="row">
                                      <div class="col-md-8 ">
                                        <div class="table-component">
                                          <div class="table-responsive">


                                            <table class="table table-striped margin-left-zero">

                                              <thead class="">
                                                <tr>
                                                  <th class="padding-top-0px padding-bottom-4px font-size-12px white-space-preline">Treatment Cycle &amp; Date</th>


                                                  <!--<th class="padding-top-4px padding-bottom-4px font-size-12px">Date</th>-->

                                                  <th class="padding-top-0px padding-bottom-4px font-size-12px white-space-preline">Cell Stage (or) Embryo Stage </th>
                                                  <!--<th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>-->
                                                  <th class="padding-top-0px padding-bottom-4px font-size-12px white-space-preline">Straw#</th>
                                                  <th class="padding-top-0px padding-bottom-4px font-size-12px white-space-preline">Old Grade</th>
                                                  <th class="padding-top-0px padding-bottom-4px font-size-12px white-space-preline">New  Grade</th>
                                                  <th class="padding-top-0px padding-bottom-4px padding-right-0px font-size-12px white-space-preline">Transfer Count</th>
                                                  <th class="padding-top-0px padding-bottom-4px padding-left-0px padding-right-0px font-size-12px white-space-preline" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'"></th>
                                                </tr>
                                              </thead>
                                              <tbody class="table-body">

                                                <tr *ngFor="let l of CurrentEmbryosFromStoreController">
                                                  <td class="">
                                                    <div> {{l.TreatmentCycle}}</div>
                                                    <div>{{l.Date|date:'MMM-dd-yyyy'}}</div>


                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px">{{l.StrawNumber}}</td>

                                                  <!--<td class="padding-top-0px padding-bottom-0px">{{l.Date|date:'MMM-dd-yyyy'}}</td>-->

                                                  <td class="padding-top-0px padding-bottom-0px">{{l.CellStage}}</td>

                                                  <!--<td class="padding-all-0px">
                                                    {{l.CellStage}}
                                                  </td>-->
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">
                                                    <label>{{l.Grade}}</label>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">
                                                    <label>{{l.Regrade}}{{l.Regrade2}}</label>
                                                  </td>
                                                  <td>{{l.Count}}</td>
                                                  <td class="padding-all-0px" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                                                    <a (click)="Editfetgrading(l)" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                                    <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>


                                                  </td>



                                                </tr>
                                              </tbody>

                                            </table>

                                          </div>
                                        </div>

                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                <div class="card margin-bottom-0px background-lightpink">

                                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                    <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero">

                                          <thead class="">
                                            <tr>
                                              <th class=" td-width-107px">Ov.Position</th>
                                              <th class="padding-left-5px width-70px">Count</th>
                                              <th class="padding-left-5px width-70px">Size</th>
                                              <th>Comments</th>

                                            </tr>
                                          </thead>
                                          <tbody class="table-body">

                                            <tr>

                                              <td>
                                                <CodeTypeValue CodeType="OVPS"
                                                               id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                                               [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                                               name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                                                </CodeTypeValue>
                                              </td>

                                              <td class="td-padding ">

                                                <input type="number" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                              </td>
                                              <td class="td-padding ">
                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                              </td>

                                              <td class="td-padding ">
                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                              </td>



                                            </tr>

                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>-->
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps overflow-x-hidden padding-lrt " data-ps-id="dfsfsde" *ngIf="SelectedpatientDetails.TCModelName=='Fet' && SelectedpatientDetails.GradingModel =='Well Culture' ">
                        <div class="accordion margin-top-10" id="accordionExamplefet">

                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingfet">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsefet" aria-expanded="true" aria-controls="collapsefet">
                                      Stored Embryos
                                    </button>
                                  </h5>
                                </div>
                                <div class="col-md-8 padding-left-0px text-align-center">
                                  <button type="button" (click)="Fetgrading()"
                                          class="btn  btn-sm drive-button3 background-primary border-all-secondary  margin-right-3px" id="FileUpload"
                                          name="upload " title="Click Here To Add New Row">
                                    <i class="fas fa-plus font-size-11"></i>
                                  </button>
                                </div>
                                <!--<div class="col-md-6">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                </div>-->
                              </div>


                            </div>

                            <div id="collapsefet" class="collapse show" aria-labelledby="headingfet" data-parent="#accordionExamplefet">
                              <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                <div class="card margin-bottom-0px margin-top-10">

                                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

                                    <div class="row">
                                      <div class="col-md-8 ">
                                        <div class="table-component">
                                          <div class="table-responsive">


                                            <table class="table table-striped margin-left-zero">

                                              <thead class="">
                                                <tr>
                                                  <th class="padding-top-0px padding-bottom-4px font-size-12px white-space-preline">Treatment Cycle &amp; Date</th>


                                                  <!--<th class="padding-top-4px padding-bottom-4px font-size-12px">Date</th>-->

                                                  <th class="padding-top-0px padding-bottom-4px font-size-12px white-space-preline">Cell Stage (or) Embryo Stage </th>
                                                  <!--<th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>-->
                                                  <th class="padding-top-0px padding-bottom-4px font-size-12px white-space-preline">Old Grade</th>
                                                  <th class="padding-top-0px padding-bottom-4px font-size-12px white-space-preline">New  Grade</th>
                                                  <th class="padding-top-0px padding-bottom-4px padding-right-0px font-size-12px white-space-preline">Transfer Count</th>
                                                  <th class="padding-top-0px padding-bottom-4px padding-left-0px padding-right-0px font-size-12px white-space-preline" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'"></th>
                                                </tr>
                                              </thead>
                                              <tbody class="table-body">

                                                <tr *ngFor="let l of CurrentEmbryosFromStoreController">
                                                  <td class="">
                                                    <div> {{l.TreatmentCycle}}</div>
                                                    <div>{{l.Date|date:'MMM-dd-yyyy'}}</div>


                                                  </td>


                                                  <!--<td class="padding-top-0px padding-bottom-0px">{{l.Date|date:'MMM-dd-yyyy'}}</td>-->

                                                  <td class="padding-top-0px padding-bottom-0px">{{l.CellStage}}</td>

                                                  <!--<td class="padding-all-0px">
                                                    {{l.CellStage}}
                                                  </td>-->
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">


                                                    <label>{{l.Grade}}</label>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">
                                                    <label>{{l.Regrade}}{{l.Regrade2}}</label>
                                                  </td>
                                                  <td>{{l.Count}}</td>
                                                  <td class="padding-all-0px" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                                                    <a (click)="Editfetgrading(l)" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                                    <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>


                                                  </td>



                                                </tr>
                                              </tbody>

                                            </table>

                                          </div>
                                        </div>

                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                <div class="card margin-bottom-0px background-lightpink">

                                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                    <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero">

                                          <thead class="">
                                            <tr>
                                              <th class=" td-width-107px">Ov.Position</th>
                                              <th class="padding-left-5px width-70px">Count</th>
                                              <th class="padding-left-5px width-70px">Size</th>
                                              <th>Comments</th>

                                            </tr>
                                          </thead>
                                          <tbody class="table-body">

                                            <tr>

                                              <td>
                                                <CodeTypeValue CodeType="OVPS"
                                                               id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                                               [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                                               name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                                                </CodeTypeValue>
                                              </td>

                                              <td class="td-padding ">

                                                <input type="number" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                              </td>
                                              <td class="td-padding ">
                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                              </td>

                                              <td class="td-padding ">
                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                              </td>



                                            </tr>

                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>-->
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>







      </div>
    </div>

  </div>
  <div class="row" *ngIf="Showivf">
    <div class="col-md-12">
      <ivfworkbench></ivfworkbench>
    </div>
  </div>
  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
